import { AxiosError } from "axios";
import { UnknownErrorOccured } from "../Constant";

export const handleAxiosError = (
  error: unknown,
  errorMessage: string
): { status?: number; message: string } => {
  if (error instanceof AxiosError) {
    return {
      status: error.status,
      message:
        error.response?.data?.errors ||
        error.response?.data?.error ||
        error.response?.data?.message ||
        errorMessage,
    };
  }
  return { message: UnknownErrorOccured };
};
